import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CommissionTracker = ({ earnings, onViewDetails }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    })?.format(amount);
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-lg bg-success/10 flex items-center justify-center">
            <Icon name="DollarSign" size={24} color="var(--color-success)" />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-foreground">Earnings</h2>
            <p className="text-sm text-muted-foreground">January 2026</p>
          </div>
        </div>
        <Button variant="outline" iconName="Download" iconPosition="left">
          Export
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <div className="p-4 rounded-lg bg-primary/5 border border-primary/20">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="TrendingUp" size={18} color="var(--color-primary)" />
            <span className="text-sm text-muted-foreground">Total Earnings</span>
          </div>
          <p className="text-2xl font-bold text-foreground">{formatCurrency(earnings?.total)}</p>
          <p className="text-xs text-success mt-1">+12% from last month</p>
        </div>

        <div className="p-4 rounded-lg bg-accent/5 border border-accent/20">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="User" size={18} color="var(--color-accent)" />
            <span className="text-sm text-muted-foreground">Personal Training</span>
          </div>
          <p className="text-2xl font-bold text-foreground">{formatCurrency(earnings?.personalTraining)}</p>
          <p className="text-xs text-muted-foreground mt-1">{earnings?.personalSessions} sessions</p>
        </div>

        <div className="p-4 rounded-lg bg-success/5 border border-success/20">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Users" size={18} color="var(--color-success)" />
            <span className="text-sm text-muted-foreground">Class Instruction</span>
          </div>
          <p className="text-2xl font-bold text-foreground">{formatCurrency(earnings?.classInstruction)}</p>
          <p className="text-xs text-muted-foreground mt-1">{earnings?.classCount} classes</p>
        </div>

        <div className="p-4 rounded-lg bg-warning/5 border border-warning/20">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Package" size={18} color="var(--color-warning)" />
            <span className="text-sm text-muted-foreground">Program Sales</span>
          </div>
          <p className="text-2xl font-bold text-foreground">{formatCurrency(earnings?.programSales)}</p>
          <p className="text-xs text-muted-foreground mt-1">{earnings?.programsSold} programs sold</p>
        </div>
      </div>
      <div className="space-y-3">
        <h3 className="text-base font-semibold text-foreground mb-3">Recent Transactions</h3>
        {earnings?.recentTransactions?.map((transaction) => (
          <div
            key={transaction?.id}
            className="flex items-center justify-between p-3 rounded-lg border border-border hover:border-primary/50 transition-all duration-250"
          >
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                transaction?.type === 'personal' ? 'bg-accent/10' :
                transaction?.type === 'class' ? 'bg-success/10' : 'bg-warning/10'
              }`}>
                <Icon
                  name={transaction?.type === 'personal' ? 'User' : transaction?.type === 'class' ? 'Users' : 'Package'}
                  size={18}
                  color={
                    transaction?.type === 'personal' ? 'var(--color-accent)' :
                    transaction?.type === 'class' ? 'var(--color-success)' : 'var(--color-warning)'
                  }
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground truncate">{transaction?.description}</p>
                <p className="text-xs text-muted-foreground">{transaction?.date}</p>
              </div>
            </div>
            <div className="text-right flex-shrink-0 ml-4">
              <p className="text-base font-semibold text-success">{formatCurrency(transaction?.amount)}</p>
              <p className="text-xs text-muted-foreground">{transaction?.status}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4">
        <Button variant="ghost" fullWidth onClick={onViewDetails}>
          View All Transactions
        </Button>
      </div>
    </div>
  );
};

export default CommissionTracker;